import React from "react";
import { VirtualGamepadTemplate } from "../constants/gamepad";
import type {
  VirtualGamepadProps,
  ButtonStates,
  Joystick,
  GamepadState,
  ButtonKey,
} from "../constants/gamepad";
import { GenericGamepad } from "./templates/GenericGamepad";
import { RacingGamepad } from "./templates/RacingGamepad";
import { SimplifiedGamepad } from "./templates/SimplifiedGamepad";
import { FightingGamepad } from "./templates/FightingGamepad";

const VirtualGamepad: React.FC<VirtualGamepadProps> = ({
  onStateChange,
  sendMessage,
  onToggleMenu,
  shouldSimulateMouseEvents,
  simulateMouseMovement,
  simulateMouseEvent,
  stopMouseSimulation,
  isActive = false,
  template = VirtualGamepadTemplate.Generic,
  dimmed = false,
}) => {
  if (!isActive) {
    return null;
  }

  const templateProps = {
    onStateChange,
    sendMessage,
    onToggleMenu,
    isActive,
    shouldSimulateMouseEvents,
    simulateMouseMovement,
    simulateMouseEvent,
    stopMouseSimulation,
  };

  const renderTemplate = () => {
    switch (template) {
      case VirtualGamepadTemplate.Generic:
        return <GenericGamepad {...templateProps} />;
      case VirtualGamepadTemplate.Racing:
        return <RacingGamepad {...templateProps} />;
      case VirtualGamepadTemplate.Simplified:
        return <SimplifiedGamepad {...templateProps} />;
      case VirtualGamepadTemplate.Fighting:
        return <FightingGamepad {...templateProps} />;
      default:
        return <GenericGamepad {...templateProps} />;
    }
  };

  return (
    <div
      style={{
        height: "100%",
        opacity: dimmed ? 0.2 : 0.8,
        transition: dimmed ? "opacity 0.5s ease" : "none",
        pointerEvents: "none",
        position: "relative",
        zIndex: 110,
      }}
    >
      {renderTemplate()}
    </div>
  );
};

export default VirtualGamepad;
export type {
  ButtonStates,
  Joystick,
  GamepadState,
  ButtonKey,
  VirtualGamepadProps,
};
export { VirtualGamepadTemplate };
